import { ApPricingAreaId } from '@admin-panel/ap-pricing'
import { ApServiceSettingsAreaId as AdminPanelServiceSettingsAreaId } from '@admin-panel/ap-service-settings'
import { CampaignBuilderAreaId } from '@admin-panel/campaign-builder'
import { RouteBuilderAreaId } from '@admin-panel/route-builder'
import { SimManagementAdminAreaId } from '@admin-panel/sim-management-admin'
import { TemporaryBackofficeSessionsAreaId } from '@admin-panel/temporary-backoffice-sessions'
import { UserManagementAreaId } from '@admin-panel/user-management'
import { VvDavtAreaId } from '@admin-panel/vv-davt'
import { FleetDashboardAreaId } from '@backoffice/fleet-dashboard'
import { FleetTracingAreaId } from '@backoffice/fleet-tracing'
import { InAppMessagesAreaId } from '@backoffice/in-app-messages'
import { RiderFeedbackAreaId } from '@backoffice/rider-feedback'
import { RoadNetworkAreaId } from '@backoffice/road-network'
import { SimManagementAreaId } from '@backoffice/sim-management'
import { TripApiConfigurationAreaId } from '@backoffice/trip-api-configuration'
import { UserManagementOrganizationAreaId } from '@backoffice/user-management-organization'
import { VehicleCapacityConfigAreaId } from '@backoffice/vehicle-capacity-config'
import { AlertsAreaId } from '@backoffice-frontend/alerts'
import { AlertsCommonAreaId } from '@backoffice-frontend/alerts-common'
import { AlertsTestingAreaId } from '@backoffice-frontend/alerts-testing'
import { AppAccessControlAreaId } from '@backoffice-frontend/app-access-control'
import { CapacityPlanningAreaId } from '@backoffice-frontend/capacity-planning'
import {
  AccidentsReportsAreaId,
  AccountingAreaId,
  AdConfigurationAreaId,
  AdFleetMapAreaId,
  CouponAreaId,
  CustomerAreaId,
  CustomerFeatureAllowlistingAreaId,
  DisruptionsAreaId,
  DsBossAreaId,
  FleetMapAreaId,
  LegalDocumentManagementAreaId,
  PatternLibraryAreaId,
  SafetyDriverGuidanceAreaId,
  ScLabsAreaId,
  VirtualAdVehiclesAreaId,
} from '@backoffice-frontend/common'
import { DriverTippingAreaId } from '@backoffice-frontend/driver-tipping'
import { EmployeeAreaId } from '@backoffice-frontend/employee'
import { EmployeeTimeManagementAreaId } from '@backoffice-frontend/employee-time-management'
import { FleetMaintenanceAreaId } from '@backoffice-frontend/fleet-maintenance'
import { FleetManagementTestingAreaId } from '@backoffice-frontend/fleet-management-testing'
import { FleetPerformanceOverviewAreaId } from '@backoffice-frontend/fleet-performance-overview'
import { FleetsAreaId } from '@backoffice-frontend/fleets'
import { KpiDashboardAreaId } from '@backoffice-frontend/kpi-dashboard'
import { MobileAppstoreAssetsAreaId } from '@backoffice-frontend/mobile-appstore-assets'
import { OfferAndPoolingAreaId } from '@backoffice-frontend/offer-and-pooling'
import { PassengerAppAreaId } from '@backoffice-frontend/passenger-app'
import { PricingAreaId } from '@backoffice-frontend/pricing'
import { StopNetworkAreaId } from '@backoffice-frontend/sam-common'
import { ServiceBreakLocationsAreaId } from '@backoffice-frontend/service-break-locations'
import { ServiceSettingsAreaId } from '@backoffice-frontend/service-settings'
import { ShiftsAreaId } from '@backoffice-frontend/shifts'
import { ShiftsCreationAreaId } from '@backoffice-frontend/shifts-creation'
import { TripAreaId } from '@backoffice-frontend/trip'
import { VehicleAreaId } from '@backoffice-frontend/vehicle'
import { VehicleAlertsAreaId } from '@backoffice-frontend/vehicle-alerts'
import { useTranslation } from 'react-i18next'
import { EvaluationAiAreaId } from '../../../../../../areas/admin-panel/evaluation-ai/src/lib/EvaluationAiAreaId'
import { IncidentAnalysisAreaId } from '../../../../../../areas/admin-panel/incident-analysis/src/lib/IncidentAnalysisAreaId'
import { TripHistoryAreaId } from '../../../../../../areas/admin-panel/trip-history/src/lib/TripHistoryAreaId'
import { VehicleDeviceManagementAdminAreaId } from '../../../../../../areas/admin-panel/vehicle-device-management-admin/src/lib/VehicleDeviceManagementAdminAreaId'
import { VehicleMonitoringAreaId } from '../../../../../../areas/admin-panel/vehicle-monitoring/src/lib/VehicleMonitoringAreaId'
import { DemoRoutesAreaId } from '../../../../../demo-routes/src/lib/DemoRoutesAreaId'
import { MobileAppFlavorConfigAreaId } from '../../../../../mobile-app-flavor-config/src/lib/MobileAppFlavorConfigAreaId'

const HubsAreaId = 'hubs' as const

export const useGetAreaTranslation = () => {
  const { t } = useTranslation()

  const getAreaTranslation = (id: string) => {
    switch (id) {
      case UserManagementAreaId:
        return t('authenticatedAppView_userManagementArea')
      case CampaignBuilderAreaId:
        return t('authenticatedAppView_campaignBuilderArea')
      case IncidentAnalysisAreaId:
        return t('authenticatedAppView_incidentAnalysisArea')
      case UserManagementOrganizationAreaId:
        return t('authenticatedAppView_userManagementArea')
      case AlertsAreaId:
        return t('authenticatedAppView_alertsArea')
      case CapacityPlanningAreaId:
        return t('authenticatedAppView_capacityPlanningArea')
      case EmployeeAreaId:
        return t('authenticatedAppView_employeeArea')
      case ShiftsAreaId:
        return t('authenticatedAppView_shiftsArea')
      case DriverTippingAreaId:
        return t('authenticatedAppView_driverTippingArea')
      case EmployeeTimeManagementAreaId:
        return t('authenticatedAppView_employeeTimeManagementArea')
      case VehicleAlertsAreaId:
        return t('authenticatedAppView_vehicleAlertsArea')
      case FleetMaintenanceAreaId:
        return t('authenticatedAppView_fleetMaintenanceArea')
      case VehicleAreaId:
        return t('authenticatedAppView_vehicleArea')
      case FleetMapAreaId:
        return t('authenticatedAppView_fleetMapArea')
      case AdFleetMapAreaId:
        return t('authenticatedAppView_adFleetMapArea')
      case StopNetworkAreaId:
        return t('authenticatedAppView_stopNetworkArea')
      case HubsAreaId:
        return t('authenticatedAppView_hubsArea')
      case CustomerAreaId:
        return t('authenticatedAppView_customerArea')
      case TripAreaId:
        return t('authenticatedAppView_tripArea')
      case EvaluationAiAreaId:
        return t('authenticatedAppView_evaluationAIArea')
      case CouponAreaId:
        return t('authenticatedAppView_couponArea')
      case AdConfigurationAreaId:
        return t('authenticatedAppView_adConfigurationArea')
      case AccountingAreaId:
        return t('authenticatedAppView_accountingArea')
      case PassengerAppAreaId:
        return t('authenticatedAppView_passengerAppArea')
      case PricingAreaId:
        return t('authenticatedAppView_pricingArea')
      case AlertsTestingAreaId:
        return t('authenticatedAppView_alertsTestingArea')
      case PatternLibraryAreaId:
        return t('authenticatedAppView_patternLibraryArea')
      case ShiftsCreationAreaId:
        return t('authenticatedAppView_shiftsCreationArea')
      case FleetManagementTestingAreaId:
        return t('authenticatedAppView_fleetManagementTestingArea')
      case VirtualAdVehiclesAreaId:
        return t('authenticatedAppView_virtualAdVehiclesArea')
      case DsBossAreaId:
        return t('authenticatedAppView_dsBossArea')
      case CustomerFeatureAllowlistingAreaId:
        return t('authenticatedAppView_customerFeatureAllowlistingArea')
      case AccidentsReportsAreaId:
        return t('authenticatedAppView_accidentsReportsArea')
      case SafetyDriverGuidanceAreaId:
        return t('authenticatedAppView_safetyDriverGuidanceArea')
      case DisruptionsAreaId:
        return t('authenticatedAppView_disruptionsArea')
      case FleetsAreaId:
        return t('authenticatedAppView_fleetsArea')
      case FleetDashboardAreaId:
        return t('authenticatedAppView_fleetDashboardArea')
      case OfferAndPoolingAreaId:
        return t('authenticatedAppView_offerAndPoolingArea')
      case ServiceSettingsAreaId:
        return t('authenticatedAppView_serviceSettingsArea')
      case LegalDocumentManagementAreaId:
        return t('authenticatedAppView_legalDocumentManagementArea')
      case FleetTracingAreaId:
        return t('authenticatedAppView_fleetTracingArea')
      case FleetPerformanceOverviewAreaId:
        return t('authenticatedAppView_fleetPerformanceOverviewArea')
      case MobileAppstoreAssetsAreaId:
        return t('authenticatedAppView_mobileAppstoreAssetsArea')
      case RoadNetworkAreaId:
        return t('authenticatedAppView_roadNetworkArea')
      case AppAccessControlAreaId:
        return t('authenticatedAppView_appAccessControlArea')
      case SimManagementAreaId:
        return t('authenticatedAppView_simManagementArea')
      case SimManagementAdminAreaId:
        return t('authenticatedAppView_simManagementAdminArea')
      case VehicleDeviceManagementAdminAreaId:
        return t('authenticatedAppView_vehicleDeviceManagementAdminArea')
      case DemoRoutesAreaId:
        return t('authenticatedAppView_demoRoutesArea')
      case RiderFeedbackAreaId:
        return t('authenticatedAppView_riderFeedbackArea')
      case ServiceBreakLocationsAreaId:
        return t('authenticatedAppView_serviceBreakLocationsArea')
      case KpiDashboardAreaId:
        return t('authenticatedAppView_serviceKpisSection_navigation')
      case ScLabsAreaId:
        return t('authenticatedAppView_scLabsSection_navigation')
      case AlertsCommonAreaId:
        return t('authenticatedAppView_hscAlerts_navigation')
      case MobileAppFlavorConfigAreaId:
        return t('authenticatedAppView_mobileAppFlavorConfigArea')
      case InAppMessagesAreaId:
        return t('authenticatedAppView_inAppMessagesArea')
      case VehicleCapacityConfigAreaId:
        return t('authenticatedAppView_vehicleCapacityConfigArea')
      case TripApiConfigurationAreaId:
        return t('authenticatedAppView_tripApiConfigurationArea')
      case VvDavtAreaId:
        return t('authenticatedAppView_vvDavtArea')
      case AdminPanelServiceSettingsAreaId:
        return t('authenticatedAppView_serviceSettingsArea')
      case ApPricingAreaId:
        return t('authenticatedAppView_pricingArea')
      case TemporaryBackofficeSessionsAreaId:
        return t('authenticatedAppView_temporaryBackofficeSessionsArea')
      case RouteBuilderAreaId:
        return t('authenticatedAppView_routeBuilderArea')
      case TripHistoryAreaId:
        return t('authenticatedAppView_tripHistoryArea')
      case VehicleMonitoringAreaId:
        return t('authenticatedAppView_vehicleMonitoringArea')
      default:
        return id
    }
  }

  return { getAreaTranslation }
}
